import { gql } from '@apollo/client'
import PropTypes from 'prop-types'
import externalPrimaryTicketShopAlertFragment, {
  externalPrimaryTicketShopAlertFragmentPropTypes,
} from '~/graphql/fragments/externalPrimaryTicketShopAlert'

export const GET_EXTERNAL_PRIMARY_TICKET_SHOP_ALERTS = gql`
  query($id: String) {
    viewer {
      id
      externalPrimaryTicketShopAlerts(first: 1, filter: { eventId: $id }) {
        edges {
          node {
            ...externalPrimaryTicketShopAlert
          }
        }
      }
    }
  }

  ${externalPrimaryTicketShopAlertFragment}
`

export const externalPrimaryTicketShopAlertsPropTypes = PropTypes.arrayOf(
  PropTypes.shape({
    node: externalPrimaryTicketShopAlertFragmentPropTypes,
  })
)
